import styled from 'styled-components';
import { BaseIcon } from './base/BaseIcon';
import d from './paths/question';

export const QuestionIcon = styled(BaseIcon).attrs({ fillRule: 'evenodd', d })``;
